import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    auctionType as auctionTypeRef,
    bidsType,
} from '../../types';
import {
    ENERGY,
    getProductType,
} from '../../utils/ProductTypes';
import AutomaticallyCancelledBidRow from './AutomaticallyCancelledBidRow';
import {
    BUY,
    getAuctionType,
} from '../../utils/AuctionTypes';
import Constants from '../../utils/Constants';
import { compareBids } from '../../utils/bids';
import SortControl from '../SortControl';

AutomaticallyCancelledBids.propTypes = {
    auction: auctionTypeRef.isRequired,
    automaticallyCancelledBidsForMember: bidsType.isRequired,
};

function AutomaticallyCancelledBids(props) {
    const {
        auction,
        automaticallyCancelledBidsForMember,
    } = props;
    const { t } = useTranslation();
    const productType = getProductType(auction.product.productType);
    const auctionType = getAuctionType(auction.auctionType);
    const [sortingParam, setSortingParam] = useState({
        key: 'price',
        direction: auctionType.is(BUY) ? Constants.SORT_DESC : Constants.SORT_ASC,
    });
    const sortedBidsForMember = automaticallyCancelledBidsForMember.sort((bid1, bid2) => compareBids(bid1, bid2, sortingParam, auctionType, t));
    return (
        <table className="list-table automatically-cancelled-bids--table">
            <thead>
                <tr>
                    <th className="automatically-cancelled-bids--table--header-row--user">
                        <SortControl sortingKey="user" sortingParam={sortingParam} onChange={setSortingParam}>
                            {t('auctions.bids-list.user')}
                        </SortControl>
                    </th>
                    {productType.is(ENERGY) && (
                        <th className="automatically-cancelled-bids--table--header-row--balancing-group">
                            <SortControl sortingKey="balancingGroup" sortingParam={sortingParam} onChange={setSortingParam}>
                                {t('auctions.bids-list.balancing-group')}
                            </SortControl>
                        </th>
                    )}
                    <th className="automatically-cancelled-bids--table--header-row--member">
                        <SortControl sortingKey="member" sortingParam={sortingParam} onChange={setSortingParam}>
                            {t('auctions.bids-list.member')}
                        </SortControl>
                    </th>
                    <th className="automatically-cancelled-bids--table--header-row--quantity">
                        <SortControl sortingKey="quantity" sortingParam={sortingParam} onChange={setSortingParam}>
                            {t('auctions.bids-list.quantity')}
                        </SortControl>
                    </th>
                    <th className="automatically-cancelled-bids--table--header-row--price">
                        <SortControl sortingKey="price" sortingParam={sortingParam} onChange={setSortingParam}>
                            {t('auctions.bids-list.price')}
                        </SortControl>
                    </th>
                    <th className="automatically-cancelled-bids--table--header-row--cancellation-reason">
                        <SortControl sortingKey="cancellationReason" sortingParam={sortingParam} onChange={setSortingParam}>
                            {t('auctions.bids-list.cancellation-reason')}
                        </SortControl>
                    </th>
                </tr>
            </thead>
            <tbody>
                {sortedBidsForMember.map((bid) => (
                    <AutomaticallyCancelledBidRow
                        key={bid.id}
                        auction={auction}
                        bid={bid}
                    />
                ))}
            </tbody>
            <tfoot>
                <tr>
                    <td />
                </tr>
            </tfoot>
        </table>
    );
}

export default AutomaticallyCancelledBids;
